import { Fragment } from 'react';

import { rage } from '~/rage';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
	</Fragment>
);

export { Background };
